<template>

    <div>

        <c_-ongoing_-quest_-cards-riddles
                class="TQ_height_100p"
                v-if="server_questBody_c && server_teamStatus_c"

                :p_system_langCode_e="store_system_langCode_ve.val"
                :p_qb_display-lang-code_e="server_questBody_c.cm_qb_getDisplayLangCode_e(store_system_langCode_ve.val)"
                :p_system_window-size-type_en="store_system_windowSizeType_ve.val"
                :p_team-status_sub-collection_e="enum_subCollection_teamStatus.CARDS_MISSIONS"


                :p_available-riddles-indexes_a="co_getRiddles_availableIndexes_an"
                :p_qb_riddles_ac="server_questBody_c.qb_cardsMissions_ac"
                :p_riddles-status_by-riddle-index_c="server_ts_riddleStatus_byIndex_c"
                :p_total-riddle-num_n="co_orderMissionsIndexes_an.length"

                :p_qb_metadata_c="server_questBody_c.qb_metadata_c"

                :p_skips-left_n="server_teamStatus_c.ts_skipsLeft_n"
                :p_clues-left_n="server_teamStatus_c.ts_cluesLeft_n"

                :p_current-user-location_c="store_system_position_vc.val"
                :p_show-skip_b="server_questBody_c.qb_metadata_c.qbm_missions_supportSkips_b"

                :p_click-get-clue_f="m_clickGetClue"
                :p_click-skip-riddle_f="m_clickGetSkip"
                :p_update-riddle-lock-answer_f="m_unlockLock"

                :pe_stop-watch-position_f="pe_stopWatchPosition_f"
                :pe_start-watch-position_f="pe_startWatchPosition_f"
                :ppe_click-image_f="m_clickImg_f"

        />

        <div v-else class="TQ_center">
            <ball-pulse-sync-loader color="#2E294E" size="10px"/>
        </div>


    </div>
</template>

<script>

    import {store_var, store_getStateValue_vo, store_setStateValue} from "../../store";
    import {
        helper_finishRiddle_fb,
    } from "@/scripts/S_Helper";
    import {
        enum_arrangeMissionsType_s, enum_finishQuest_s,
        enum_subCollection_teamStatus
    } from "../../../functions/src/shareCode/Share_S_Enum";


    import C_Ongoing_Quest_CardsRiddles from "./V_Ongoing_Cards/C_Ongoing_Quest_CardsRiddles";
    import {serverBig_questBody_once_fp} from "@/scripts/Server/S_ServerFirestore";
    import {
        serverOngoing_teamStatus_subCollection_cl_get_f,
        serverOngoing_teamStatus_subCollection_cl_remove_f,
        serverOngoing_teamStatusSub_riddleStatus_unlockData_update_f,
        serverOngoing_teamStatus_riddleStatus_useClue_update_f,
        serverOngoing_teamStatusSub_riddleStatus_useSkip_f,
        serverOngoing_gameStatus_vl_set_f,
        serverOngoing_gameStatus_vl_remove_f,
        serverOngoing_teamStatus_vl_set_f,
        serverOngoing_teamStatus_vl_remove_f,
    } from "@/scripts/Server/S_ServerOngoing";
    import {
        serverAuth_currentUserData_remove_vl_f
    } from "@/scripts/Server/S_ServerAuth";
    import {serverAuth_currentUserData_get_vl_fp} from "@/scripts/Server/S_ServerAuth";
    import {FB_RiddleStatus} from "../../../functions/src/shareCode/Share_S_Classes";

    export default {
        name: "V_Ongoing_Cards",
        components: {
            C_Ongoing_Quest_CardsRiddles,
        },
        props:{
            pe_startWatchPosition_f:{
                type: Function,
                require: true
            },
            pe_stopWatchPosition_f:{
                type: Function,
                require: true
            }

        },
        data(){
            return {

                cardsMissionsIndex_byRiddleId_n : {},

                // === store ===
                store_questEvent_c      : store_getStateValue_vo(store_var.ongoing_questEvent).val,
                store_currentTeamId_uid : store_getStateValue_vo(store_var.ongoing_currentTeamId_uid).val,
                store_system_langCode_ve: store_getStateValue_vo(store_var.system_langCode),
                store_system_position_vc: store_getStateValue_vo(store_var.system_currentUserLocation),
                store_system_windowSizeType_ve: store_getStateValue_vo(store_var.system_windowSizeType_e),

                // === server ===
                server_questBody_c          : undefined,
                server_currentUserData_c    : undefined,
                server_gameStatus_c         : undefined,
                server_teamStatus_c         : undefined,
                server_ts_riddleStatus_byIndex_c : {},

                // imports
                enum_subCollection_teamStatus : enum_subCollection_teamStatus

            }
        },
        computed : {

            // all riddles indexes
            co_orderMissionsIndexes_an(){

                if(!this.server_questBody_c || !this.server_gameStatus_c || !this.store_currentTeamId_uid || !this.server_currentUserData_c){
                    return [];
                }

                let missionsArrangementIndex_n = null
                switch (this.server_questBody_c.qb_metadata_c.qbm_quest_missionsArrangements_e){

                    case enum_arrangeMissionsType_s.team_choose_oneTime:
                        missionsArrangementIndex_n = this.server_gameStatus_c.gs_teams_byTeamId[this.store_currentTeamId_uid].gst_missionsArrangementIndex_n
                        break;
                    case enum_arrangeMissionsType_s.player_choose_oneTime:
                        missionsArrangementIndex_n = this.server_gameStatus_c.gs_teams_byTeamId[this.store_currentTeamId_uid].gst_players_byUserId_c[this.server_currentUserData_c.ud_userId_uid].gstp_pathIndex_n
                        break;
                }

                let missionsArrangementIndexes_an = this.server_questBody_c.cm_qb_getMissionsArrangement_an(missionsArrangementIndex_n, enum_subCollection_teamStatus.CARDS_MISSIONS)
                return missionsArrangementIndexes_an
            },

            // all riddles available Indexes
            co_getRiddles_availableIndexes_an(){
                let ans = []

                if(!this.server_questBody_c || !this.server_teamStatus_c || !this.server_gameStatus_c){
                    return ans;
                }

                let missionsArrangementIndexes_an = this.co_orderMissionsIndexes_an

                missionsArrangementIndexes_an.some((riddleIndex_n) => {
                    ans.push(riddleIndex_n)

                    let riddleData_c    = this.server_questBody_c.qb_cardsMissions_ac[riddleIndex_n]
                    let riddleStatus_c  = this.server_ts_riddleStatus_byIndex_c[riddleIndex_n]

                    return !helper_finishRiddle_fb(riddleData_c, riddleStatus_c)
                })

                return ans;
            },
        },

        methods:{


            m_clickImg_f(imgSrc_s){
                store_setStateValue(store_var.ongoing_fullScreenImage_s, imgSrc_s)
            },


            // users events
            m_clickGetClue(riddleIndex_n, clueIndex_n, cb_f) {


                serverOngoing_teamStatus_riddleStatus_useClue_update_f({
                    questEvent_c                : this.store_questEvent_c,
                    teamId_uid                  : this.store_currentTeamId_uid,
                    userId_uid                  : this.server_currentUserData_c.ud_userId_uid,
                    teamStatus_subCollection_e  : enum_subCollection_teamStatus.CARDS_MISSIONS,
                    riddleData_c                : this.server_questBody_c.qb_cardsMissions_ac[riddleIndex_n],
                    teamStatus_c: this.server_teamStatus_c,

                    clueId_n                    : clueIndex_n,
                    clueMode_e                  : this.server_questBody_c.qb_metadata_c.qbm_missions_cluesMode_e,
                    cb_f                        : cb_f
                })
            },
            m_clickGetSkip(riddleIndex_n, unlocksData_byLockId, cb_f) {
                let riddleData_c = this.server_questBody_c.qb_cardsMissions_ac[riddleIndex_n]


                serverOngoing_teamStatusSub_riddleStatus_useSkip_f({
                    questEvent_c                : this.store_questEvent_c,
                    teamId_uid                  : this.store_currentTeamId_uid,
                    userId_uid                  : this.server_currentUserData_c.ud_userId_uid,
                    teamStatus_subCollection_e  : enum_subCollection_teamStatus.CARDS_MISSIONS,
                    riddleId_n                  : riddleData_c.qbr_riddleId_n,
                    unlocksData_byLockId        : unlocksData_byLockId,

                    finishRiddle_fb : () => {
                        let rs_riddle_c = this.server_ts_riddleStatus_byIndex_c[riddleIndex_n]

                        return helper_finishRiddle_fb(riddleData_c, rs_riddle_c)
                    },
                    lastRiddle_fb : () => this.co_orderMissionsIndexes_an.indexOf(riddleIndex_n)+ 1 === this.co_orderMissionsIndexes_an.length,

                    cb_f : cb_f
                })
            },
            m_unlockLock(riddleIndex_n, lockIndex_n, rs_unlocksData_c, cb_f) {

                let riddleData_c = this.server_questBody_c.qb_cardsMissions_ac[riddleIndex_n]

                serverOngoing_teamStatusSub_riddleStatus_unlockData_update_f({
                    questEvent_c                : this.store_questEvent_c,
                    teamId_uid                  : this.store_currentTeamId_uid,
                    userId_uid                  : this.server_currentUserData_c.ud_userId_uid,
                    teamStatus_subCollection_e  : enum_subCollection_teamStatus.CARDS_MISSIONS,
                    lockIndex_n                 : lockIndex_n,
                    rs_lockData_c               : rs_unlocksData_c,
                    riddleData_c                : riddleData_c,
                    questSupportPoints_b        : this.server_questBody_c.qb_metadata_c.qbm_missions_supportMissionsPoints_b,

                    questLastRiddle_b           : this.server_questBody_c.qb_metadata_c.qbm_quest_finishQuest_e === enum_finishQuest_s.cardsLastRiddle
                                                    && this.co_orderMissionsIndexes_an.indexOf(riddleIndex_n)+ 1 === this.co_orderMissionsIndexes_an.length,
                    riddleStatus_c              : this.server_ts_riddleStatus_byIndex_c[riddleIndex_n],

                    cb_f : cb_f
                })
            },


        },

        created(){

            // 0) current user data
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (userData_c) => {
                this.server_currentUserData_c = userData_c
            })

            // 1) get gameStatus
            serverOngoing_gameStatus_vl_set_f(
                this.$options.name,
                this.store_questEvent_c.qev_questType_e,
                this.store_questEvent_c.qev_questId_uid,
                this.store_questEvent_c.qev_eventId_uid,
                true,
                (gameStatus_c)=>{
                    this.server_gameStatus_c = gameStatus_c
                })

            // 2) questBody_C
            serverBig_questBody_once_fp(this.store_questEvent_c.qev_questType_e, this.store_questEvent_c.qev_questId_uid, false, false, (questBody_c)=>{

                this.server_questBody_c = questBody_c;

                this.server_questBody_c.qb_cardsMissions_ac.forEach((qb_riddle_c, index_n)=> {
                    this.cardsMissionsIndex_byRiddleId_n[qb_riddle_c.qbr_riddleId_n] = index_n
                })


                // 3) teamStatus_subCollection
                serverOngoing_teamStatus_subCollection_cl_get_f({
                    viewName_s: this.$options.name,
                    subCollectionName_e: enum_subCollection_teamStatus.CARDS_MISSIONS,
                    questEvent_c: this.store_questEvent_c,
                    teamId_uid: this.store_currentTeamId_uid,
                    cb_ChildAdded_f: (riddleStatus_c) => {

                        let index_n = this.cardsMissionsIndex_byRiddleId_n[riddleStatus_c.rs_riddleId_n]
                        this.$set(this.server_ts_riddleStatus_byIndex_c, index_n, riddleStatus_c)

                    },
                })

            })

            serverOngoing_teamStatus_vl_set_f({
                viewName_s: this.$options.name, 
                questEvent_c : this.store_questEvent_c, 
                teamId_uid : this.store_currentTeamId_uid,
                cb_f: (teamStatus_c) => {
                    this.server_teamStatus_c = teamStatus_c
                }
            })


        },
        destroyed(){

            // user data
            serverAuth_currentUserData_remove_vl_f(this.$options.name)

            // gameStatus
            serverOngoing_gameStatus_vl_remove_f(this.$options.name, this.store_questEvent_c)

            // teamStauts
            serverOngoing_teamStatus_vl_remove_f(this.$options.name, this.store_questEvent_c, this.store_currentTeamId_uid);

            // current riddleStatus riddles
            serverOngoing_teamStatus_subCollection_cl_remove_f({
                viewName_s          : this.$options.name,
                subCollectionName_e : enum_subCollection_teamStatus.CARDS_MISSIONS,
                questEvent_c        : this.store_questEvent_c,
                teamId_uid          : this.store_currentTeamId_uid,
            })

        },
    }
</script>

<style scoped lang="scss">
    .lc_location{
        position: absolute;
        bottom: 54px;
        width: 100%;
    }
</style>
